import { AppContent, AppSidebar, AppFooter, AppHeader } from "./index";
import OddsConverter from "components/OddsConverter";

const AppLayout = () => {
  return (
    <div>
      <AppSidebar />
      <div className="wrapper d-flex flex-column min-vh-100 bg-light">
        <AppHeader />
        <div className="body flex-grow-1 px-3">
          <AppContent />
        </div>
        <AppFooter />
      </div>
      <OddsConverter />
    </div>
  );
};

export default AppLayout;
